<app-modal-title i18n>{{title}}</app-modal-title>
<app-modal-body>
    <div class="ot-mr-1 ot-ml-1 ot-mb-1">
        <app-user-form [type]="formType" [currentTab]="UserFormTab.GENERAL" [currentUserAuthInfo]="currentUserAuthInfo" (formEvent)="updateUserForm($event)" [isEditRoleAllowed] = true (errorEvent)="cancel()" [formHeight]="formHeight"></app-user-form>
    </div>
</app-modal-body>
<app-modal-footer>
    <button [id]="primaryButtonId" otsc-button color="primary" [disabled]="userForm.invalid || userForm.controls.dataCtrl.invalid" (click)="submit()" i18n>
        {{primaryButton}}
    </button>
    <button id="user-cancel-btn" otsc-button color="secondary" (click)="cancel()" i18n>
        Cancel
    </button>
</app-modal-footer>